window.compatManufacturers = [
  {
    "name": "101voice",
    "slug": "101voice",
    "count": 6
  },
  {
    "name": "3COM",
    "slug": "3com",
    "count": 16
  },
  {
    "name": "8x8 (Packet8)",
    "slug": "8x8-packet8",
    "count": 1
  },
  {
    "name": "ADTRAN (Polycom)",
    "slug": "adtran-polycom",
    "count": 6
  },
  {
    "name": "AT&T / Lucent / Avaya",
    "slug": "at-t-lucent-avaya",
    "count": 188
  },
  {
    "name": "Agptek",
    "slug": "agptek",
    "count": 3
  },
  {
    "name": "AirWay",
    "slug": "airway",
    "count": 3
  },
  {
    "name": "Alcatel (Alcatel-Lucent)",
    "slug": "alcatel-alcatel-lucent",
    "count": 10
  },
  {
    "name": "Allworx",
    "slug": "allworx",
    "count": 10
  },
  {
    "name": "Alphacom",
    "slug": "alphacom",
    "count": 1
  },
  {
    "name": "Altigen",
    "slug": "altigen",
    "count": 11
  },
  {
    "name": "Amazon",
    "slug": "amazon",
    "count": 2
  },
  {
    "name": "Ameriphone",
    "slug": "ameriphone",
    "count": 2
  },
  {
    "name": "Amtelco",
    "slug": "amtelco",
    "count": 1
  },
  {
    "name": "Apple",
    "slug": "apple",
    "count": 17
  },
  {
    "name": "Atcom",
    "slug": "atcom",
    "count": 1
  },
  {
    "name": "AudioCodes",
    "slug": "audiocodes",
    "count": 11
  },
  {
    "name": "Blackberry",
    "slug": "blackberry",
    "count": 1
  },
  {
    "name": "Broadview Networks",
    "slug": "broadview-networks",
    "count": 2
  },
  {
    "name": "Brother",
    "slug": "brother",
    "count": 1
  },
  {
    "name": "CQ Simple",
    "slug": "cq-simple",
    "count": 3
  },
  {
    "name": "CXC",
    "slug": "cxc",
    "count": 7
  },
  {
    "name": "Callany",
    "slug": "callany",
    "count": 2
  },
  {
    "name": "CapTel (captioned phones)",
    "slug": "captel-captioned-phones",
    "count": 2
  },
  {
    "name": "Chameleon",
    "slug": "chameleon",
    "count": 1
  },
  {
    "name": "Ciglow",
    "slug": "ciglow",
    "count": 1
  },
  {
    "name": "Cisco",
    "slug": "cisco",
    "count": 98
  },
  {
    "name": "Clarity(Amplified Phones)",
    "slug": "clarity-amplified-phones",
    "count": 6
  },
  {
    "name": "ClearCaptions",
    "slug": "clearcaptions",
    "count": 1
  },
  {
    "name": "ClearSounds",
    "slug": "clearsounds",
    "count": 1
  },
  {
    "name": "Comdial",
    "slug": "comdial",
    "count": 151
  },
  {
    "name": "Computer",
    "slug": "computer",
    "count": 16
  },
  {
    "name": "Conair",
    "slug": "conair",
    "count": 6
  },
  {
    "name": "Concord",
    "slug": "concord",
    "count": 7
  },
  {
    "name": "Conveyant Systems",
    "slug": "conveyant-systems",
    "count": 1
  },
  {
    "name": "Cortelco (also ITT)",
    "slug": "cortelco-also-itt",
    "count": 28
  },
  {
    "name": "Crest",
    "slug": "crest",
    "count": 2
  },
  {
    "name": "Crexendo",
    "slug": "crexendo",
    "count": 10
  },
  {
    "name": "Cytracom",
    "slug": "cytracom",
    "count": 1
  },
  {
    "name": "DELL",
    "slug": "dell",
    "count": 1
  },
  {
    "name": "Denwa",
    "slug": "denwa",
    "count": 1
  },
  {
    "name": "Diebold Nixdorf",
    "slug": "diebold-nixdorf",
    "count": 1
  },
  {
    "name": "Durabrand",
    "slug": "durabrand",
    "count": 1
  },
  {
    "name": "E-MetroTel",
    "slug": "e-metrotel",
    "count": 3
  },
  {
    "name": "ESI",
    "slug": "esi",
    "count": 32
  },
  {
    "name": "Emerson",
    "slug": "emerson",
    "count": 1
  },
  {
    "name": "Engenius (Cordless)",
    "slug": "engenius-cordless",
    "count": 6
  },
  {
    "name": "Equiinet",
    "slug": "equiinet",
    "count": 3
  },
  {
    "name": "Executive Pro",
    "slug": "executive-pro",
    "count": 1
  },
  {
    "name": "Executone",
    "slug": "executone",
    "count": 61
  },
  {
    "name": "Fanstel",
    "slug": "fanstel",
    "count": 1
  },
  {
    "name": "Fanvil",
    "slug": "fanvil",
    "count": 20
  },
  {
    "name": "Fortinet / FortiFone/ Talkswitch",
    "slug": "fortinet-fortifone-talkswitch",
    "count": 26
  },
  {
    "name": "Futura Comminications",
    "slug": "futura-comminications",
    "count": 1
  },
  {
    "name": "Geemarc",
    "slug": "geemarc",
    "count": 6
  },
  {
    "name": "General Electric (GE)",
    "slug": "general-electric-ge",
    "count": 5
  },
  {
    "name": "Gigaset (USE Siemens/Unify)",
    "slug": "gigaset-use-siemens-unify",
    "count": 1
  },
  {
    "name": "Google",
    "slug": "google",
    "count": 11
  },
  {
    "name": "Grandstream",
    "slug": "grandstream",
    "count": 50
  },
  {
    "name": "HTC",
    "slug": "htc",
    "count": 1
  },
  {
    "name": "HePesTer",
    "slug": "hepester",
    "count": 2
  },
  {
    "name": "Htek",
    "slug": "htek",
    "count": 4
  },
  {
    "name": "IPitomy",
    "slug": "ipitomy",
    "count": 1
  },
  {
    "name": "Inter-Tel",
    "slug": "inter-tel",
    "count": 9
  },
  {
    "name": "Iwatsu",
    "slug": "iwatsu",
    "count": 20
  },
  {
    "name": "KerLiTar",
    "slug": "kerlitar",
    "count": 1
  },
  {
    "name": "Key Systems US/KS Telecom",
    "slug": "key-systems-us-ks-telecom",
    "count": 2
  },
  {
    "name": "Kyocera",
    "slug": "kyocera",
    "count": 2
  },
  {
    "name": "LG Ericsson",
    "slug": "lg-ericsson",
    "count": 13
  },
  {
    "name": "LG Stylo",
    "slug": "lg-stylo",
    "count": 1
  },
  {
    "name": "Lenoxx",
    "slug": "lenoxx",
    "count": 1
  },
  {
    "name": "Linksys (Telephony - Use Cisco)",
    "slug": "linksys-telephony-use-cisco",
    "count": 4
  },
  {
    "name": "MCHEETA",
    "slug": "mcheeta",
    "count": 1
  },
  {
    "name": "MOTOROLA/Cassidian/Pallas",
    "slug": "motorola-cassidian-pallas",
    "count": 21
  },
  {
    "name": "MacroTel",
    "slug": "macrotel",
    "count": 12
  },
  {
    "name": "Med Pat",
    "slug": "med-pat",
    "count": 2
  },
  {
    "name": "Medtel (Renamed Telatronics)",
    "slug": "medtel-renamed-telatronics",
    "count": 1
  },
  {
    "name": "Microsoft",
    "slug": "microsoft",
    "count": 22
  },
  {
    "name": "Mitel (Includes rebranded Shoretel)",
    "slug": "mitel-includes-rebranded-shoretel",
    "count": 131
  },
  {
    "name": "NEC",
    "slug": "nec",
    "count": 49
  },
  {
    "name": "Nextiva",
    "slug": "nextiva",
    "count": 4
  },
  {
    "name": "Norcon Communications",
    "slug": "norcon-communications",
    "count": 1
  },
  {
    "name": "Northcom Premier",
    "slug": "northcom-premier",
    "count": 1
  },
  {
    "name": "Northern Telecom (Nortel,Meridian, Aastra,Ameritech)",
    "slug": "northern-telecom-nortel-meridian-aastra-ameritech",
    "count": 90
  },
  {
    "name": "Obihai",
    "slug": "obihai",
    "count": 4
  },
  {
    "name": "OnePlus",
    "slug": "oneplus",
    "count": 1
  },
  {
    "name": "Ooma",
    "slug": "ooma",
    "count": 9
  },
  {
    "name": "Ornin",
    "slug": "ornin",
    "count": 2
  },
  {
    "name": "Packet8 VOIP (also 8x8)",
    "slug": "packet8-voip-also-8x8",
    "count": 1
  },
  {
    "name": "Panasonic",
    "slug": "panasonic",
    "count": 240
  },
  {
    "name": "Phillips/TMC",
    "slug": "phillips-tmc",
    "count": 1
  },
  {
    "name": "Planet",
    "slug": "planet",
    "count": 1
  },
  {
    "name": "Plantronics",
    "slug": "plantronics",
    "count": 7
  },
  {
    "name": "Polycom",
    "slug": "polycom",
    "count": 67
  },
  {
    "name": "RCA",
    "slug": "rca",
    "count": 18
  },
  {
    "name": "Radio Shack",
    "slug": "radio-shack",
    "count": 2
  },
  {
    "name": "SBC",
    "slug": "sbc",
    "count": 1
  },
  {
    "name": "Samsung",
    "slug": "samsung",
    "count": 126
  },
  {
    "name": "Sangoma",
    "slug": "sangoma",
    "count": 25
  },
  {
    "name": "Scitec",
    "slug": "scitec",
    "count": 2
  },
  {
    "name": "Shorete",
    "slug": "shorete",
    "count": 13
  },
  {
    "name": "Siemens / Unify",
    "slug": "siemens-unify",
    "count": 32
  },
  {
    "name": "Snom",
    "slug": "snom",
    "count": 22
  },
  {
    "name": "Softphones",
    "slug": "softphones",
    "count": 251
  },
  {
    "name": "Sony",
    "slug": "sony",
    "count": 2
  },
  {
    "name": "Sparsh",
    "slug": "sparsh",
    "count": 1
  },
  {
    "name": "Symphony",
    "slug": "symphony",
    "count": 1
  },
  {
    "name": "T.I.E.",
    "slug": "t-i-e",
    "count": 2
  },
  {
    "name": "TEO (Tone Commander)",
    "slug": "teo-tone-commander",
    "count": 3
  },
  {
    "name": "TMC",
    "slug": "tmc",
    "count": 2
  },
  {
    "name": "Tadiran",
    "slug": "tadiran",
    "count": 5
  },
  {
    "name": "Telos",
    "slug": "telos",
    "count": 2
  },
  {
    "name": "Telrad",
    "slug": "telrad",
    "count": 2
  },
  {
    "name": "Teltronics",
    "slug": "teltronics",
    "count": 1
  },
  {
    "name": "Toshiba",
    "slug": "toshiba",
    "count": 149
  },
  {
    "name": "TransTel",
    "slug": "transtel",
    "count": 1
  },
  {
    "name": "Transtel Communications",
    "slug": "transtel-communications",
    "count": 3
  },
  {
    "name": "Ubiquiti Unified Networks",
    "slug": "ubiquiti-unified-networks",
    "count": 4
  },
  {
    "name": "Uniden",
    "slug": "uniden",
    "count": 17
  },
  {
    "name": "Uvital",
    "slug": "uvital",
    "count": 1
  },
  {
    "name": "VTech",
    "slug": "vtech",
    "count": 44
  },
  {
    "name": "Verizon",
    "slug": "verizon",
    "count": 3
  },
  {
    "name": "Vertical Networks",
    "slug": "vertical-networks",
    "count": 19
  },
  {
    "name": "Vocera",
    "slug": "vocera",
    "count": 2
  },
  {
    "name": "Vodavi",
    "slug": "vodavi",
    "count": 1
  },
  {
    "name": "Voixis",
    "slug": "voixis",
    "count": 3
  },
  {
    "name": "WIN Phone",
    "slug": "win-phone",
    "count": 1
  },
  {
    "name": "Wildix",
    "slug": "wildix",
    "count": 4
  },
  {
    "name": "XBlue Networks",
    "slug": "xblue-networks",
    "count": 6
  },
  {
    "name": "Yealink",
    "slug": "yealink",
    "count": 66
  },
  {
    "name": "Zenitel",
    "slug": "zenitel",
    "count": 2
  },
  {
    "name": "Zultys",
    "slug": "zultys",
    "count": 19
  }
];
